import { MESApiService, getMomentTz, spParameter } from "@dexteel/mesf-core";
import { DelayByShift } from "../../delays-manager/models/DelayByShift";
import { CatalogDelayCode } from "../models/CatalogDelayCode";

const moment = getMomentTz();

export const upsertDelay = async (delayCode: CatalogDelayCode) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    {
      name: "DelayAreaAssetId",
      value: delayCode.DelayAreaAssetId,
    },
    { name: "DelayCodeId", value: delayCode.DelayCodeId },
    { name: "DelayCodeName", value: delayCode.DelayCodeName },
    {
      name: "ParentDelayCodeId",
      value:
        delayCode.ParentDelayCodeId === 0 ? null : delayCode.ParentDelayCodeId,
    },
    {
      name: "DefaultDelayCategoryId",
      value: delayCode.DelayCategoryId,
    },
  ];

  return await apiService.callV2(`[DEL].[UpsertDelayCode]`, parameters);
};

export const deleteDelay = async (delayCodeId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "DelayCodeId", value: delayCodeId },
  ];

  return await apiService.callV2(`[DEL].[DeleteDelayCode]`, parameters);
};

export const getDelays = async (assetId?: number, signal?: AbortSignal) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  if (assetId) parameters.push({ name: "DelayAreaAssetId", value: assetId });

  return await apiService.callV2("[DEL].[GetDelayCodes]", parameters, signal);
};

export const getDelayCode = async (
  DelayCodeId: number,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "DelayCodeId", value: DelayCodeId });
  return await apiService.callV2("[DEL].[GetDelayCode]", parameters, signal);
};

export const getDelayById = async (delayId: number, signal?: AbortSignal) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "DelayId", value: delayId });

  const resp = await apiService.callV2("[DEL].[GetDelay]", parameters, signal);

  if (resp.ok) {
    let rows = (resp?.data?.tables?.[0]?.rows ?? []) as DelayByShift[];

    rows = rows.map((delay: DelayByShift) => ({
      ...delay,
      Start: delay.Start ? moment.utc(delay["Start"]).toDate() : null,
      End: delay.End ? moment.utc(delay["End"]).toDate() : null,
    }));

    return {
      ok: true,
      data: rows[0],
    };
  } else {
    return {
      ok: false,
      message: resp.message,
    };
  }
};

export const reorderDelays = async (
  DelayCodeId: (string | number)[],
  AboveDelayCodeId: number | null,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    {
      name: "DelayCodeId",
      value: DelayCodeId.join(","),
    },
    { name: "AboveDelayCodeId", value: AboveDelayCodeId },
  ];

  return await apiService.callV2("[DEL].[ChangeParentDelayCode]", parameters);
};

export const moveDelayCode = async (
  DelayCodeId: number | null,
  MoveDown: boolean | null,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    {
      name: "DelayCodeId",
      value: DelayCodeId,
    },
    { name: "MoveDown", value: MoveDown },
  ];

  return await apiService.callV2("[DEL].[MoveDelayCode]", parameters);
};
